import { CANONICAL_SITE_URL } from '@/constants/metadata';
import { ORGANIZATION_ENTITY_ID } from '@/constants/schema-ids';
import {
	SERVICE_AREA_SERVED,
	SERVICE_AUDIENCE,
	ServiceSchemaConfig
} from '@/constants/service-schema';
import { StrapiSeo } from '@/types/common';

export type ServiceSeo = Pick<StrapiSeo, 'title' | 'description'>;

export const buildServiceJsonLd = (config: ServiceSchemaConfig, seo?: ServiceSeo | null) => {
	const base = CANONICAL_SITE_URL.replace(/\/$/, '');

	return {
		'@context': 'https://schema.org',
		'@type': 'Service',
		// "||" on purpose: an empty string from the CMS must fall back to the
		// approved marketing copy too, not reach the schema.
		name: seo?.title || config.name,
		alternateName: config.alternateName,
		description: seo?.description || config.description,
		serviceType: config.serviceType,
		url: `${base}${config.path}`,
		provider: {
			'@type': 'Organization',
			'@id': ORGANIZATION_ENTITY_ID,
			name: 'Qream',
			url: CANONICAL_SITE_URL
		},
		audience: SERVICE_AUDIENCE,
		areaServed: SERVICE_AREA_SERVED
	};
};
